import { getJson, getNonCachedJson } from "./http";
import { AllowedProjectsList, AssetsLibrary, AssetsLibTab, DomainConfiguration, ErrorHelpData, OnboardingData, ProjectData, QuestData } from "../core/types";

export async function requestDomainSettings(domainName : string, domainPath : string): Promise<DomainConfiguration> {
  const data = await getNonCachedJson(`${domainPath + domainName }.json`);
  return data;
}

export async function requestProjectList(path : string): Promise<AllowedProjectsList> {
  const data = await getNonCachedJson(path);
  return data;
}

export async function requestI18nFile(path : string): Promise<any> {
  const data = await getNonCachedJson(path);
  return data;
}

export async function requestAssetsI18nFile(path : string): Promise<any> {
  const data = await getNonCachedJson(path);
  return data;
}

export async function requestViewConfiguration(path : string): Promise<any> {
  const data = await getNonCachedJson(path);
  return data;
}

export async function loadProjectJson(projectUrl : string, jsonFileName? : string) : Promise<ProjectData> {
  let projectJson = jsonFileName ? jsonFileName : "project.json";
  const data = await getJson(`${projectUrl}/${projectJson}`);
  return data;
}

export async function loadQuestJson(questUrl : string) : Promise<QuestData> {  
  const data = await getJson(questUrl);
  return data;
}

export async function loadLibAssets(path : string) : Promise<AssetsLibrary> {
  const data : AssetsLibrary = await getNonCachedJson(path);
  let newDataTabs : AssetsLibTab[] = [];
  for (let i = 0; i < data.tabs.length; i++) {
    const element = data.tabs[i];
    let entryContent;
    if (element.file) {
      entryContent = await getJson(element.file);
    } else if (element.files) {
      const assetList = [];
      for (let j = 0; j < element.files.length; j++) {
        const file = element.files[j];
        const list = await getJson(file.file);
        assetList.push({
          ...file,
          assets: list.assets.assets
        })
      }
      entryContent = { assets : assetList }
    }
    const newEntry : AssetsLibTab = {
      ...element,
      data : entryContent.assets
    }
    newDataTabs = [...newDataTabs, newEntry];
  }
  return { tabs : newDataTabs };
}

export async function getOnboardingData(path: string): Promise<OnboardingData> {
  const data : OnboardingData = await getNonCachedJson(path);
  return data;
}

export async function getErrorHelpData(path: string): Promise<ErrorHelpData> {
  const data : ErrorHelpData = await getNonCachedJson(path);
  return data;
}
